import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { last, size } from 'lodash/fp';
import { CheckBoxOutlineBlank, RadioButtonUnchecked } from '@material-ui/icons';

const S = {
  Wrapper: styled.div.attrs(({ position }) => ({
    style: {
      transform: `translate(${position.x + 2}px, ${position.y + 2}px)`,
    },
  }))`
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    cursor: none;
  `,
  Number: styled.div`
    min-width: 32px;
    padding: 1px 4px 2px;
    border-radius: 2px;
    color: ${({ theme }) => theme.palette.primary.contrastText};
    background-color: ${({ theme }) => theme.palette.primary.translucent};
    font-size: ${({ theme }) => theme.typography.pxToRem(13)};
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.32);
  `,
  Mesh: styled.div`
    position: relative;
    display: flex;
    ::before {
      content: '';
      position: absolute;
      top: 50%;
      right: 4px;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      opacity: 0.54;
      border-radius: 50%;
      background-color: ${({ theme }) => theme.palette.primary.contrastText};
      ${({ rounded }) => rounded && css`
        right: 2px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
    `}
    }
  `,
  CheckBoxOutlineBlank: styled(CheckBoxOutlineBlank)`
    position: relative;
    color: ${({ theme }) => theme.palette.grey[600]};
  `,
  RadioButtonUnchecked: styled(RadioButtonUnchecked)`
    position: relative;
    color: ${({ theme }) => theme.palette.grey[600]};
  `,
  FieldRect: styled.div.attrs(({ viewportWidth }) => ({
    style: {
      width: `${viewportWidth * 0.25}px`,
    },
  }))`
    height: 20px;
    padding: 2px 4px;
    color: ${({ theme }) => theme.palette.primary.light};
    background-color: #e5e7f0;
    font-size: ${({ theme }) => theme.typography.pxToRem(10)};
    font-weight: 500;
    line-height: 1.56;
    box-shadow: 0 1px 2px 0 rgba(93, 108, 164, 0.54);
  `,
};

const OptionCursorFollower = ({
  bindHover, position, questions, type, optionType, viewportWidth,
}) => (
  <S.Wrapper position={position} rounded={type === 'SINGLE_SELECTION'} {...bindHover}>
    <S.Number>{`${size(questions)}-${size(last(questions).options) + 1}`}</S.Number>
    <S.Mesh>
      {type === 'SINGLE_SELECTION' ? <S.RadioButtonUnchecked /> : <S.CheckBoxOutlineBlank />}
    </S.Mesh>
    {optionType === 'TEXT' && (
      <S.FieldRect viewportWidth={viewportWidth}>
        기타 의견을 입력하세요.
      </S.FieldRect>
    )}
  </S.Wrapper>
);

OptionCursorFollower.propTypes = {
  bindHover: PropTypes.shape({
    onMouseEnter: PropTypes.func.isRequired,
    onMouseLeave: PropTypes.func.isRequired,
  }).isRequired,
  position: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }).isRequired,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      options: PropTypes.arrayOf(
        PropTypes.shape({
          number: PropTypes.number.isRequired,
          content: PropTypes.string.isRequired,
          position: PropTypes.shape({
            x: PropTypes.number.isRequired,
            y: PropTypes.number.isRequired,
          }),
        }),
      ),
    }),
  ).isRequired,
  type: PropTypes.oneOf(['SINGLE_SELECTION', 'MULTIPLE_SELECTION']),
  optionType: PropTypes.oneOf(['SELECTION', 'TEXT']).isRequired,
  viewportWidth: PropTypes.number.isRequired,
};

OptionCursorFollower.defaultProps = {
  type: null,
};

export default OptionCursorFollower;
